import './Main.css';
import ProductDetail from './ProductDetail/ProductDetail';

const Main = () => {
  return (
    <div className="main">
      <ProductDetail />
    </div>
  );
};

export default Main;
